module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAIAAAAlV+npAAABZ0lEQVR4AWKYzStrwsLFMAoA7dclWAQBGIRhesK94O5uCQrSkILVq7hLwiveabhX3HcPd7eCuzvkGxx2/ueLdyvvuiIzomL6EMkALICMWAAZsQAyYgFkxALIiAWQEYtkABbJUCyS4Vgkw7FIhmORDMciGY6FkxELqM7QMd4vIOxfDID1kWaDIo46++/++ABYJAOwSAZgkQzDmnDwlRgZjiXq2wva1qKu3al8YkTNXNSzE3VsJUKGY+nZnc3MHw+JD3846h06HhQEdQupXZjAZbhVVPL2n9XYLIncy3AsVbP1tNy7m5u3/9yeXyzLEqSKpUCiju3t5dXN8cnl5ragbS0pJhxLz263pllu6LLX0C4xJhxL0LB4vqkL2tb/j4kvpfzc4Yc0sXAmYtW5esdly0KqMv5BX4hVaWXtHO2ulOrzfyITEJmAyAREJiAyAZEJiExAZAIiExDAxAAmBjAxgIkBTExxJnYPmGldlMN8hCUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/jo.png
// module id = 0eiJ
// module chunks = 0